import React, { useState } from 'react';
import './gpt.css';

const GEMINI_API_KEY = "AIzaSyC0bipGDs9lGV05b17lhrt8ebcmK1BRNZ4";

const GPTChat = () => {
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const sendToGemini = async () => {
    if (!userInput.trim()) return;

    const newMessage = {
      sender: 'You',
      text: userInput,
      AiMsg: ''
    };

    setUserInput('');
    setIsLoading(true);

    try {
      const response = await fetch(
        `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-pro:generateContent?key=${GEMINI_API_KEY}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            contents: [{ parts: [{ text: userInput }] }]
          })
        }
      );

      const data = await response.json();
      const aiReply = data.candidates?.[0]?.content?.parts?.[0]?.text || 'No response received.';

      newMessage.AiMsg = aiReply;
      setMessages((prevMessages) => [...prevMessages, newMessage]);
    } catch (error) {
      console.error('Error from Gemini:', error);
      newMessage.AiMsg = 'Something went wrong. Please try again.';
      setMessages((prevMessages) => [...prevMessages, newMessage]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='flex justify-center xxs:mb-44'>
      <div className="form-container border-y-8 w-full h-full border border-[#0000ff] hover:scale-105 hover:shadow-2xl hover:shadow-white shadow-inner-white">
        <div className="form">
          <span className="heading text-center font-serif">AI CHAT_BOARD </span>

          {messages.map((msg, index) => (
            <div className='my-4' key={index}>
              {msg && <label className='font-bold text-[#0000ff] text-xl'>You :-</label>}
              <input
                placeholder={msg.sender}
                value={msg.text}
                disabled
                type="text"
                className="input"
              />
              {msg && <label className='font-bold text-[#0000ff] text-xl'>AI Ans :-</label>}
              <textarea
                placeholder={isLoading ? 'Typing...' : 'AI Ans'}
                disabled
                value={msg.AiMsg}
                rows={4}
                cols={30}
                className="textarea"
              />
            </div>
          ))}

          {isLoading && <h1 className='text-white xxs:text-base sm:text-xl font-serif text-center'>Typing...</h1>}

          <div className="button-container">
            <input
              placeholder="Type Message"
              type="text"
              className="input"
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
            />
            <div className="reset-button-container">
              <div
                id="reset-btn"
                className="reset-button shadow-inner-white font-serif bg-slate-500"
                onClick={sendToGemini}
              >
                Send
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GPTChat;
